import { listDataExtensionSchemas } from '@wix/bex-utils/@wix/ambassador-data-extensions-v1-data-extension-schema/http';
import { ListDataExtensionSchemasResponse } from '@wix/bex-utils/@wix/ambassador-data-extensions-v1-data-extension-schema/types';

export function dataExtensionServiceMocks(
  whenRequest: typeof import('@wix/http-client-testkit/client').whenRequest,
) {
  return {
    mocks: [
      whenRequest(listDataExtensionSchemas)
        .reply(200, async () => {
          const res: ListDataExtensionSchemasResponse = {
            dataExtensionSchemas: [],
          };

          return res;
        })
        .persist(),
    ] as import('@wix/http-client-testkit').AnyScenario[],
  };
}
